import cookieUtils from './cookieUtils';
import {getAvailableDevices} from '../pages/skincarepro/uiconfiguration/config/utils/optionsUtils';
import _get from 'lodash/get';

const langCode = {
  consoleLanguageMapping: {
    en: 'enu',
    fr: 'fra',
    de: 'deu',
    es: 'esp',
    pt: 'ptb',
    it: 'ita',
    ru: 'rus',
    cht: 'cht',
    chs: 'chs',
    ja: 'jpn',
    ko: 'kor',
    nl: 'nld',
    th: 'tha',
    tr: 'tur',
    ar: 'ara',
    bg: 'bul',
    cs: 'ces',
    da: 'dan',
    el: 'ell',
    et: 'est',
    fi: 'fin',
    hr: 'hrv',
    hu: 'hun',
    id: 'ind',
    lv: 'lav',
    lt: 'lit',
    ms: 'msa',
    no: 'nor',
    pl: 'pol',
    ro: 'rum',
    sk: 'slk',
    sl: 'slv',
    sr: 'srp',
    sv: 'swe',
    uk: 'ukr',
    vi: 'vie',
  },
  consoleLanguageMappingUrl: {
    en: 'en_US',
    fr: 'fr_FR',
    ja: 'ja_JP',
    tw: 'zh_TW',
    cn: 'zh_CN',
    ko: 'ko_KR',
    de: 'de_DE',
    es: 'es_ES',
    it: 'it_IT',
    pt: 'pt_PT',
    ar: 'ar_AE',
  },
  convertLanguageCode(lang = 'en') {
    let languageCode = [
      {language: 'zh_tw', langCode: 'cht'},
      {language: 'zh-tw', langCode: 'cht'},
      {language: 'zh_cn', langCode: 'chs'},
      {language: 'zh-cn', langCode: 'chs'},
      {language: 'en', langCode: 'enu'},
      {language: 'es', langCode: 'esp'},
      {language: 'pt', langCode: 'ptb'},
      {language: 'it', langCode: 'ita'},
      {language: 'de', langCode: 'deu'},
      {language: 'ja', langCode: 'jpn'},
      {language: 'ko', langCode: 'kor'},
      {language: 'fr', langCode: 'fra'},
      {language: 'ar', langCode: 'ara'},
    ];
    for (let l in languageCode) {
      if (languageCode[l].language === lang.toLowerCase()) {
        return languageCode[l].langCode;
      }
    }
    return 'enu';
  },
  convertToFrontendLangUrl(lang = 'en') {
    let languageCode = [
      {language: 'tw', langCode: '/zh-tw'},
      {language: 'cn', langCode: '/zh-cn'},
      {language: 'en', langCode: ''},
      {language: 'es', langCode: '/es'},
      {language: 'pt', langCode: '/pt'},
      {language: 'it', langCode: '/it'},
      {language: 'de', langCode: '/de'},
      {language: 'ja', langCode: '/ja'},
      {language: 'ko', langCode: '/ko'},
      {language: 'fr', langCode: '/fr'},
      {language: 'ar', langCode: ''},
    ];
    for (let l in languageCode) {
      if (languageCode[l].language === lang.toLowerCase()) {
        return languageCode[l].langCode;
      }
    }
    return '';
  },
  getAppLang() {
    return cookieUtils.getCookie('appLang') === 'cht'
      ? 'zh-Hant'
      : cookieUtils.getCookie('appLang') === 'chs'
      ? 'zh-Hans'
      : Object.keys(this.consoleLanguageMapping).find(
          key =>
            this.consoleLanguageMapping[key] ===
            cookieUtils.getCookie('appLang')
        );
  },
  langList() {
    return [
      {
        label: 'English',
        value: 'enu',
        valueForConsole: 'en',
        valueForConsoleString: 'en-us',
      },
      {
        label: 'Français',
        value: 'fra',
        valueForConsole: 'fr',
        valueForConsoleString: 'fr-fr',
      },
      {
        label: '日本語',
        value: 'jpn',
        valueForConsole: 'ja',
        valueForConsoleString: 'ja-jp',
      },
      {
        label: '繁體中文',
        value: 'cht',
        valueForConsole: 'cht',
        valueForConsoleString: 'zh-tw',
      },
      {
        label: '简体中文',
        value: 'chs',
        valueForConsole: 'chs',
        valueForConsoleString: 'zh-cn',
      },
      {
        label: '한국어',
        value: 'kor',
        valueForConsole: 'ko',
        valueForConsoleString: 'ko-kr',
      },
      {
        label: 'Deutsch',
        value: 'deu',
        valueForConsole: 'de',
        valueForConsoleString: 'de-de',
      },
      {
        label: 'Español',
        value: 'esp',
        valueForConsole: 'es',
        valueForConsoleString: 'es-es',
      },
      {
        label: 'Italiano',
        value: 'ita',
        valueForConsole: 'it',
        valueForConsoleString: 'it-it',
      },
      {
        label: 'Português',
        value: 'ptb',
        valueForConsole: 'pt',
        valueForConsoleString: 'pt-pt',
      },
      {
        label: 'العربية',
        value: 'ara',
        valueForConsole: 'ar',
        valueForConsoleString: 'ar-ae',
      },
    ];
  },
  getAppLangList() {
    return langCode.langList().map(item => ({
      label: item.label,
      value: item.value,
    }));
  },
  getConsoleLangList() {
    return langCode.langList().map(item => ({
      label: item.label,
      value: item.valueForConsole,
    }));
  },
  getConsoleStringLangList() {
    return langCode.langList().map(item => ({
      label: item.label,
      value: item.valueForConsoleString,
    }));
  },
  getConsoleStringLangToLabelMap() {
    return Object.fromEntries(
      langCode.langList().map(lang => [lang.valueForConsoleString, lang.label])
    );
  },
  getLanguageByValue: (list, lang) => {
    return list.find(language => language.value === lang) || list[0];
  },
  getInitialLang: function() {
    return (
      langCode
        .getAppLangList()
        .find(l => l.value === cookieUtils.getCookie('appLang')) ||
      langCode.getAppLangList()[0]
    );
  },
  getAvailableConsoleStringLangList: function(availableConsoleStringLangList) {
    return langCode
      .getConsoleStringLangList()
      .filter(option => availableConsoleStringLangList.includes(option.value));
  },
  getMappedLangKey(lang) {
    return lang === 'tw'
      ? 'zh-Hant'
      : lang === 'cn'
      ? 'zh-Hans'
      : Object.keys(this.consoleLanguageMapping || {}).find(
          key => this.consoleLanguageMapping[key] === lang
        ) || lang;
  },
  getAdjustedMaxLength(maxLength, languageCode) {
    const doubleByteLanguages = [
      'zh-Hant',
      'zh-Hans',
      'ko',
      'ja',
      'cht',
      'chs',
      'kor',
      'jpn',
    ];
    return doubleByteLanguages.includes(languageCode)
      ? Math.floor(maxLength / 2)
      : maxLength;
  },
};

export default langCode;
